import type {
  PiMatrixAgentChangeSet,
  PiMatrixAgentSnapshot,
} from './piMatrixAgent'
import type { AnchoredRow } from './anchoredRowTypes'
import type { ChapterCharacterLayer } from './characterLayerTypes'
import type { LedgerSafeEditorialEvent } from './ledgerSafeEditorialEvents'
import type { Witness } from '../store/booksStore'

export const LEDGER_SAFE_AGENT_CHANGE_SET_SCHEMA_VERSION = 1 as const
export const LEDGER_SAFE_AUTHORITY_HEAD_SCHEMA_VERSION = 1 as const

export interface LedgerSafeAgentRecoveryState {
  rows: AnchoredRow[]
  witnesses: Witness[]
  characterLayer?: ChapterCharacterLayer
}

export interface LedgerSafeAgentChangeSetApplication {
  appliedAt: string
  before: LedgerSafeAgentRecoveryState
  after: LedgerSafeAgentRecoveryState
  beforeAuthority: LedgerSafeAuthorityHeadRecord
  afterAuthority: LedgerSafeAuthorityHeadRecord
  editorialEventId: string
  undoneAt?: string
  undoAuthority?: LedgerSafeAuthorityHeadRecord
  undoEditorialEventId?: string
}

export type LedgerSafeAgentChangeSetRecord = PiMatrixAgentChangeSet & {
  id: string
  schemaVersion: typeof LEDGER_SAFE_AGENT_CHANGE_SET_SCHEMA_VERSION
  chapterId: string
  bookId?: string
  inquiryId?: string
  baseAuthorityRevisionId: string
  baseContentHash: string
  persistedAt: string
  application?: LedgerSafeAgentChangeSetApplication
}

export interface LedgerSafeAuthorityHeadRecord {
  chapterId: string
  schemaVersion: typeof LEDGER_SAFE_AUTHORITY_HEAD_SCHEMA_VERSION
  bookId?: string
  authorityRevisionId: string
  contentHash: string
  updatedAt: string
  sourceChangeSetId?: string
}

export interface LedgerSafeAgentChangeSetDraft {
  changeSet: PiMatrixAgentChangeSet
  snapshot: Pick<PiMatrixAgentSnapshot, 'authorityRevisionId' | 'contentHash'>
  chapterId: string
  bookId?: string
  inquiryId?: string
}

export interface LedgerSafeAgentAtomicMutation {
  changeSetId: string
  expectedChangeSetStatus: LedgerSafeAgentChangeSetRecord['status']
  expectedAuthority: Pick<LedgerSafeAuthorityHeadRecord, 'chapterId' | 'authorityRevisionId' | 'contentHash'>
  expectedState: LedgerSafeAgentRecoveryState
  nextState: LedgerSafeAgentRecoveryState
  nextChangeSet: LedgerSafeAgentChangeSetRecord
  nextAuthority: LedgerSafeAuthorityHeadRecord
  editorialEvent: LedgerSafeEditorialEvent
}
